window.filterByColor = function(dataLabel) {
	const parents = dataLabel.closest('.product-information__grid');
	const altEl = parents.querySelectorAll('.custom-data-alt');
	altEl.forEach(el => {
		let dataAlt = el.getAttribute('data-alt')?.toLowerCase() || '';
		const checkedColorInput = document.querySelector('.product-details legend[data-label="finish"]')?.closest('fieldset')?.querySelector('input:checked').value.toLowerCase() || null;
		const lockTypeInput = document.querySelector('.product-details legend[data-label="lock type"]')?.closest('fieldset')?.querySelector('input:checked').value.toLowerCase() || null;
		const checkedSizeInput = document.querySelector('.product-details legend[data-label="size"]')?.closest('fieldset')?.querySelector('input:checked').value.toLowerCase() || null;
		
		// Always show if data-alt is empty
		
		if (dataAlt === '') {
			el.classList.add('show');
			return;
		}

		// Show if matches selected color
		// if (dataAlt.includes('|') || dataAlt.includes(checkedColorInput) || dataAlt.includes(lockTypeInput)) {
		let mergedAlt = null;
		if(checkedColorInput){
			mergedAlt = '#' + checkedColorInput;
		}
		if(lockTypeInput){
			mergedAlt = mergedAlt + '#' + lockTypeInput;
		}
		if(checkedSizeInput){
			mergedAlt =  '#' + checkedSizeInput;
		}
		if(mergedAlt){
			mergedAlt = mergedAlt.replace(/\s+/g, '');
		}
		dataAlt = dataAlt.replace(/\s+/g, '');
//console.log("dataAlt"+dataAlt);
//console.log("mergedAlt"+mergedAlt);
		if (dataAlt.includes('|') || dataAlt == mergedAlt) {
			el.classList.add('show');
		} else {
			el.classList.remove('show');
		}
	});

	const shownInMain = document.querySelectorAll('.product-information__grid slideshow-container .custom-data-alt.show');
	if(shownInMain){
		shownInMain.forEach(el => {
			const index = el.getAttribute('data-index');
			const target = document.querySelector(`.product-information__grid slideshow-controls .custom-data-alt[data-index="${index}"]`);
			if (target) target.classList.add('show');
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const dataLabel = document.querySelector('.product-details legend[data-label="finish"]') || null;
	if(dataLabel){
		const checkedColorInput = document.querySelector('.product-details legend[data-label="finish"]')?.closest('fieldset')?.querySelector('input:checked') || null;
		if(checkedColorInput){
			checkedColorInput.checked = false;
			checkedColorInput.closest('label').click();
			window.filterByColor(dataLabel);
		}
	}
	const dataLabelsize = document.querySelector('.product-details legend[data-label="size"]') || null;
	if(dataLabelsize){
		const checkedSizeInput = document.querySelector('.product-details legend[data-label="size"]')?.closest('fieldset')?.querySelector('input:checked') || null;
		if(checkedSizeInput){
			checkedSizeInput.checked = false;
			checkedSizeInput.closest('label').click();
			window.filterByColor(dataLabelsize);
		}
	}

});